import React from "react";
import { motion } from "framer-motion";
import Folder from "./Folder";

export default function Projects() {
  const openRepo = () => {
    window.open("https://github.com/iamneo-production/f66a8d60-c00f-4358-aaa2-f5a11961fa26-924bb567-be75-4dec-aa74-04830b4399e7", "_blank");
  };

  return (
    <section id="projects" className="max-w-4xl mx-auto px-6 pb-24">
      <motion.h2
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        className="text-xl font-bold text-black dark:text-white mb-8"
      >
        Projects
      </motion.h2>

      {/* same alignment width */}
      <div className="max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
          viewport={{ once: true }}
          className="w-full"
        >
          {/* ✅ Glass Card like Skills/Education */}
          <div
            onClick={openRepo}
            className="group cursor-pointer select-none
            w-[340px] h-[340px]
            rounded-3xl border border-black/10 dark:border-white/10
            bg-white/60 dark:bg-white/5 backdrop-blur-xl
            shadow-[0_10px_30px_rgba(0,0,0,0.10)] dark:shadow-[0_10px_30px_rgba(0,0,0,0.45)]
            hover:border-black/20 dark:hover:border-white/20
            transition overflow-hidden relative"
            title="Open GitHub Repository"
          >
            {/* subtle glow like other cards */}
            <div className="pointer-events-none absolute -top-24 -left-24 h-72 w-72 rounded-full bg-purple-500/15 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-sky-500/15 blur-3xl" />

            {/* Folder area */}
            <div className="relative h-[220px] flex items-center justify-center">
              <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.25 }}>
                <Folder color="#7c3aed" size={1.9} />
              </motion.div>
            </div>

            {/* Divider */}
            <div className="relative mx-6 h-px bg-black/10 dark:bg-white/10" />

            {/* Text */}
            <div className="relative px-6 pt-5">
              <p className="text-[16px] font-semibold text-black dark:text-white">
                Vehicle Rental Management System
              </p>

              <p className="mt-1 text-[14px] text-black/60 dark:text-white/70">
                React + Spring Boot + MySQL
              </p>

              <p className="mt-3 text-xs text-black/40 dark:text-white/40">
                Click folder to view repository
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
